!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("timesince", [], t) : "object" == typeof exports ? exports.timesince = t() : e.timesince = t();
}(this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var r = n[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 0);
  }([function (e, t, n) {
    "use strict";

    var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        r = n(1),
        i = [60, 60, 24, 7, 365 / 7 / 12, 12],
        u = function u(e, t, n) {
      for (var o = e < 0 ? 1 : 0, r = 0, u = Math.abs(e); u >= i[r] && r < 6; r++) {
        u /= i[r];
      }

      return u = parseInt(u, 10), r *= 2, u > (0 === r ? 9 : 1) && (r += 1), t(u, r, n)[o].replace("%s", u);
    },
        f = function f() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "en",
          t = void 0 === e ? "undefined" : o(e);
      if ("function" === t) return e;
      if ("string" === t && r[e]) return r[e];
      if (r.en) return r.en;
      throw new Error('locale "' + e + '" not found!');
    },
        c = function c(e) {
      var t = void 0 === e ? "undefined" : o(e);
      if ("number" === t) return e;

      if ("string" === t) {
        var n = new Date(e).getTime();
        if (isFinite(n)) return n;
      }

      return e instanceof Date ? e.getTime() : Date.now();
    },
        s = function s() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.now,
          n = e.locale,
          o = e.options;
      return function (e) {
        var r = f(n),
            i = c(t) - c(e);
        return u(i / 1e3, r, o);
      };
    };

    e.exports = s;
  }, function (e, t, n) {
    "use strict";

    e.exports = [];
  }]);
});